import requireAuth from "../context/requireAuth";
import axios from "../context/axiosConfig";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Home() {

    const org_id = localStorage.getItem("organization");

    const [user, setUser] = useState({})
    console.log(user)
    useEffect(() => {
        axios.get("fullname", {withCredentials: true})
            .then(res => setUser(res.data))
            .catch(err => console.log(err));
    }, [])
   
    useEffect(() => {
        document.title = "Innexo - Welcome";
    }, [])

    const [isAdmin, setIsAdmin] = useState(false)

    useEffect(() => {
        axios.get(`${org_id}/checkuser`, {withCredentials: true})
            .then(res => {
            if (res.data.role === "admin") {
                setIsAdmin(true);
            }
            })
            .catch(err => console.log(err));
    }, [])

    return(
        <div className="bodyContent">
            <div className="centered">
               <h1 className="title"> Hi {user?.full_name}, <br />
                welcome to your dashboard!
                </h1>
                <div className="homeGrid">
                    <Link to="/roomselect">
                        <div className="purpleBox">
                            <p className="linkText">Room & Plots</p>
                        </div>
                    </Link>
                    <Link to="/plantSelect">
                    <div className="purpleBox">
                        <p className="linkText">Plants</p>
                    </div>
                    </Link>
                    {/* <Link to="/editAccount">
                    <div className="purpleBox">
                        <p className="linkText">Alter Account</p>
                    </div>
                    </Link> */}
                    <Link to="maintenance">
                    <div className="purpleBox">
                        <p className="linkText">Maintenance</p>
                    </div>
                    </Link>
                    <Link to="product">
                        <div className="purpleBox">
                            <p className="linkText">Product</p>
                        </div>
                        </Link>
                    {isAdmin && (
                    <Link to="signatures">
                    <div className="purpleBox">
                        <p className="linkText">Signatures</p>
                    </div>
                    </Link>
                    )}
                    <Link to="createNew">
                    <div className="purpleBox">
                        <p className="linkText">Create New</p>
                    </div>
                    </Link>
                </div>
                </div>
            </div>
    )
}

export default requireAuth(Home);